"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponent = exports.valueOrDefault = exports.getResult = exports.emptyToSpace = exports.sanitizeHTML = void 0;
const vue_1 = __importDefault(require("vue"));
const _ = __importStar(require("lodash"));
const core_1 = require("@integro/core");
const entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
};
function sanitizeHTML(value) {
    if (value) {
        return String(value).replace(/[&<>"'`=\/]/g, s => entityMap[s]);
    }
    return value;
}
exports.sanitizeHTML = sanitizeHTML;
function emptyToSpace(value) {
    return value === null || typeof value === 'undefined' || value === ''
        ? '&nbsp;'
        : value;
}
exports.emptyToSpace = emptyToSpace;
function getResult(value) {
    if (_.isFunction(value)) {
        return value();
    }
    return value;
}
exports.getResult = getResult;
function valueOrDefault(value, defaultValue) {
    if (_.isNull(value) || _.isUndefined(value)) {
        return defaultValue;
    }
    return value;
}
exports.valueOrDefault = valueOrDefault;
function createComponent(name, template, data, props = ['value', 'row']) {
    return {
        name,
        ...vue_1.default.compile(template),
        props,
        data() {
            return data ? (0, core_1.deepCopy)(data) : {};
        }
    };
}
exports.createComponent = createComponent;
//# sourceMappingURL=helpers.js.map